import baseRoute from '../baseRoute';

export default `${baseRoute}/purchaseOrder` as const;
